module.exports = __webpack_public_path__ + "img/4d.df4a56d9.png";